module.exports = __webpack_public_path__ + "img/阵列.8dc5ec52.svg";